export const PORTAL_ROOT_ID = 'lens-ui-portal-modal-root';

export const CLASSES = {
  NoSelect: 'lens-ui-no-select',

  Typography: 'lens-ui-typography',

  Table: 'lens-ui-table',

  IntentPrimary: 'lens-ui-intent-primary',
  IntentSecondary: 'lens-ui-intent-secondary',
  IntentSuccess: 'lens-ui-intent-success',
  IntentDanger: 'lens-ui-intent-danger',
  IntentInfo: 'lens-ui-intent-info',
  IntentWarning: 'lens-ui-intent-warning',

  IntentPrimaryLight: 'lens-ui-intent-primary-light',
  IntentSecondaryLight: 'lens-ui-intent-secondary-light',
  IntentSuccessLight: 'lens-ui-intent-success-light',
  IntentDangerLight: 'lens-ui-intent-danger-light',
  IntentInfoLight: 'lens-ui-intent-info-light',
  IntentWarningLight: 'lens-ui-intent-warning-light',

  IntentPrimaryLighten: 'lens-ui-intent-primary-lighten',
  IntentSecondaryLighten: 'lens-ui-intent-secondary-lighten',
  IntentSuccessLighten: 'lens-ui-intent-success-lighten',
  IntentDangerLighten: 'lens-ui-intent-danger-lighten',
  IntentInfoLighten: 'lens-ui-intent-info-lighten',
  IntentWarningLighten: 'lens-ui-intent-warning-lighten',

  IntentPrimaryDark: 'lens-ui-intent-primary-dark',
  IntentSecondaryDark: 'lens-ui-intent-secondary-dark',
  IntentSuccessDark: 'lens-ui-intent-success-dark',
  IntentDangerDark: 'lens-ui-intent-danger-dark',
  IntentInfoDark: 'lens-ui-intent-info-dark',
  IntentWarningDark: 'lens-ui-intent-warning-dark',

  IntentPrimaryDarken: 'lens-ui-intent-primary-darken',
  IntentSecondaryDarken: 'lens-ui-intent-secondary-darken',
  IntentSuccessDarken: 'lens-ui-intent-success-darken',
  IntentDangerDarken: 'lens-ui-intent-danger-darken',
  IntentInfoDarken: 'lens-ui-intent-info-darken',
  IntentWarningDarken: 'lens-ui-intent-warning-darken',

  PortalRootContainer: 'lens-ui-portal-root',

  InputText: {
    className: 'lens-ui-input-text',
    size: {
      large: 'size-large',
      small: 'size-small',
      medium: 'size-medium',
    },
  },

};
